'use strict';

require("./RetailerChangeEmptyShoppingCartController");
require("./RetailerLimitController");
require("./RetailerLimitShowDetailController");
require("./RetailsController");
require("./RetailTargetsService");